<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $t("cash_card_gallery") }}</div>
      </div>
      <div>
        <b-button
          v-if="$can('create', 'CAsh Card Gallery')"
          variant="default"
          to="cash-cards-template"
          class="btn-blue"
          >{{ $tc("add") }}</b-button
        >
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center my-3">
      <div>
        <b-form-input
          v-model="searchValue"
          v-debounce:800="onSearch"
          placeholder="Search..."
        ></b-form-input>
      </div>
      <div class="d-flex"></div>
      <div class="d-flex align-items-center justify-content-between w-100">
        <FilterByStatusDropdown
          :onSelect="
            (filterIsActive) => {
              this.filter_is_active = filterIsActive;
              this.getWebsiteCashCards();
            }
          "
        />
        <div class="mx-2">
          <b-dropdown id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              href="#"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <!-- LIST VIEW DESIGNATION -->
    <table class="list-view-table">
      <thead>
        <tr>
          <th>
            {{ $t("w_cash_card_name") }}
          </th>
          <th>{{ $t("issuer") }}</th>
          <th class="text-right">
            <span class="pr-5">{{ $t("card") }}</span>
          </th>
        </tr>
      </thead>

      <tbody v-if="cashCardList.length > 0">
        <tr v-for="(card, cardIndex) in cashCardList" :key="cardIndex">
          <td>{{ card.w_cash_card_name }}</td>
          <td>{{ card.w_issuer_name }}</td>
          <td>
            <div class="d-flex align-items-center justify-content-end">
              <img
                v-lazy="_GetImagePath(card.w_cash_card_image)"
                width="140"
                height="80"
                class="br-12"
              />
              <StatusDot
                :status="
                  card.w_is_active == 'Y'
                    ? 'active'
                    : card.w_is_active == 'N' && 'inactive'
                "
                class="ml-3"
              />
              <b-dropdown right variant="edit">
                <b-dropdown-item
                  v-if="$can('update', 'CAsh Card Gallery')"
                  @click="goToRoute('/marketing/cash-cards-template', card)"
                >
                  <span class="edit-pen"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr>
          <td colspan="3">
            <NoRecords />
          </td>
        </tr>
      </tbody>
    </table>
    <b-pagination
      v-if="rows > 0"
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import PosFnbService from "@/services/PosFnbService";
import { BASEURL } from "@/config/index.js";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";
import _ from "lodash";
import MarketingService from "@/services/MarketingService";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords,
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      listView: true,
      URL_BASE: BASEURL,
      searchValue: "",

      //sorting
      isSort: false,
      isAscending: false,
      columnName: "",
      orderBy: "",
      cashCardList: [],
      filter_is_active: "Y",
    };
  },
  watch: {},
  mounted() {},
  beforeMount() {
    this.getviewingnumber();
    this.getWebsiteCashCards();
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  methods: {
    onSortValue(columnName, orderBy) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderBy = orderBy;
      this.getWebsiteCashCards();
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },
    onChangePagination(event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getWebsiteCashCards();
      } else {
        this.currentPage = event;
        this.getWebsiteCashCards();
      }
    },
    onSearch(event) {
      this.searchValue = event;
      this.currentPage = 1;
      this.getWebsiteCashCards();
    },
    getWebsiteCashCards() {
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        searchValue: this.searchValue,
        columnName: this.columnName,
        orderBy: this.orderBy,
        filter_is_active: this.filter_is_active,
      };

      let loader = this.$loading.show();
      this.cashCardList = [];
      MarketingService.GetWebsiteCashCards(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records && data.Records.length > 0) {
            this.cashCardList = data.Records;
            if (data.pagination.total) {
              this.rows = data.pagination.total;
            }
            this.selectedvalue = data.pagination.to - data.pagination.from;
          } else {
            this.cashCardList = [];
            this.selectedvalue = 0;
            this.rows = 0;
            this.$toasted.show(this.$t("No Records Found"));
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        })
        .finally(() => setTimeout(() => loader.hide(), 1000));
    },
    goToRoute: function (path, { w_cash_card_unique_id }) {
      this.$router.push({
        path: path,
        query: {
          w_cash_card_unique_id: w_cash_card_unique_id,
        },
      });
    },
  },
};
</script>
<style>
.br-12 {
  border-radius: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/CashCardGallery/listCashCardGallery.vue